if(window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

var replaceText = function(text, textElement) {
        $(textElement).html(text.replace(/(?:\r\n|\r|\n)/g, '<br>'));
    },

    showText = function() {
        $('.frame-type-mask_ce_video_teaser .video-teaser-text h1').show();
    },

    hideText = function() {
        $('.frame-type-mask_ce_video_teaser .video-teaser-text h1').hide();
    },

    cueEnter = function() {
        replaceText(this.text, this.textElement);
        //showText();
    },

    cueExit = function() {
        //hideText();
    },

    videoLoaded = function(e) {
        let video = e.target,
            cues = video.textTracks[0].cues,
            textElement = video.parentNode.querySelector('h1');
        for (let i=0; i<cues.length; i++) {
            let cue = cues[i];
            cue.textElement = textElement;
            cue.onenter = cueEnter;
            cue.onexit = cueExit;
        }
    };

function addSourceToVideo(element, src) {
    let source = document.createElement('source');
    source.src = src;
    source.type = 'video/mp4';
    element.appendChild(source);

}

function whichSizeVideo(element, src) {
    let windowWidth = window.innerWidth ? window.innerWidth : $(window).width();
    if (windowWidth > 576 ) {
        addSourceToVideo(element, src.dataset.videoDesktop);
    } else {
        addSourceToVideo(element, src.dataset.videoMobile);
    }
}

function startMutedVideo(videoContainer) {
    if (!$(videoContainer).hasClass("video-active")) {
        let video = $(videoContainer).children("video").get(0);
        video.muted = 1;
        video.loop = 1;
        video.play();
    }
}

function stopMutedVideo(videoContainer) {
    if (!$(videoContainer).hasClass("video-active")) {
        let video = $(videoContainer).children("video").get(0);
        video.pause();
    }
}

function startStopVideo(videoContainer) {
    let video = $(videoContainer).children("video").get(0);
    if (!$(videoContainer).hasClass("video-active")) {
        // stop all videos
        $(".video-manual").each(function () {
            $(this).removeClass("video-active");
            let video = $(this).children("video").get(0);
            video.muted = 1;
            video.loop = 1;
            video.pause();
        });
        // start current video with audio from beginning
        video.muted = 0;
        video.currentTime = 0;
        video.loop = 0;
        video.play();
        $(videoContainer).addClass("video-active");
    } else if (video.paused) {
        // resume current video
        video.play();
    } else {
        // pause current video
        video.pause();
    }
}

function initMoreVideos() {
    $(".video-preview.video-ajax").on("mouseover", function () {
        startMutedVideo(this);
    }).on("mouseout", function () {
        stopMutedVideo(this)
    }).removeClass("video-ajax");
}

function initVideo() {
    let video = document.querySelectorAll('video');
    if (video !== undefined) {
        video.forEach(function (element, index) {
            let tracks = element.textTracks;
            if (tracks.length > 0) {
                tracks[0].mode = 'hidden';
                element.addEventListener('loadedmetadata', videoLoaded);
            }
            whichSizeVideo(
                element, //element
                element  //src locations
            );
        });
    }
    let $previewVideos = $(".video-preview");
    let $manualVideos = $(".video-manual");
    if ($previewVideos.length) {
        $previewVideos.on("mouseover", function () {
            startMutedVideo(this);
        }).on("mouseout", function () {
            stopMutedVideo(this)
        });
    }
    if ($manualVideos.length) {
        $manualVideos.each(function () {
            let video = $(this).children("video").get(0);
            video.controls = false;
            video.addEventListener('ended', function (e) {
                // set video inactive again when it has ended
                $(e.target).closest(".video-manual").removeClass("video-active");
            });
        });
        $manualVideos.on("click", function() {
            startStopVideo(this);
        });
    }
}
